<div class="aza-cart-v2-order-items-card">
  <div class="aza-cart-v2-order-items-title">
    <ng-content select="[aza-cart-v2-order-items-card-view-title]"></ng-content>
  </div>
</div>
@for (item of orderItems; track getOrderItemTrackByValue(item, $index)) {
  <div class="aza-cart-v2-order-items-card aza-vertical-stack">
    <aza-rws-shopping-cart-v2-order-items-card-view-row>
      <span aza-cart-v2-order-items-card-row-label translate>DATE</span>
      <span aza-cart-v2-order-items-card-row-value>{{item.transaction_date | eventDate}}</span>
    </aza-rws-shopping-cart-v2-order-items-card-view-row>
    <aza-rws-shopping-cart-v2-order-items-card-view-row>
      <span aza-cart-v2-order-items-card-row-label translate>QUANTITY</span>
      <span aza-cart-v2-order-items-card-row-value>{{item.quantity}}</span>
    </aza-rws-shopping-cart-v2-order-items-card-view-row>
    <aza-rws-shopping-cart-v2-order-items-card-view-row>
      <span aza-cart-v2-order-items-card-row-label translate>NAME</span>
      <span aza-cart-v2-order-items-card-row-value>{{item.product_name}}</span>
    </aza-rws-shopping-cart-v2-order-items-card-view-row>
    <aza-rws-shopping-cart-v2-order-items-card-view-row>
      <span aza-cart-v2-order-items-card-row-label translate>UNIT_PRICE</span>
      <span aza-cart-v2-order-items-card-row-value>{{item.unit_price | twoDecNumber | addText:cartCurrency}}</span>
    </aza-rws-shopping-cart-v2-order-items-card-view-row>
    <aza-rws-shopping-cart-v2-order-items-card-view-row>
      <span aza-cart-v2-order-items-card-row-label translate>DISCOUNT</span>
      <span aza-cart-v2-order-items-card-row-value>{{item.discount | twoDecNumber | addText:cartCurrency}}</span>
    </aza-rws-shopping-cart-v2-order-items-card-view-row>
    <aza-rws-shopping-cart-v2-order-items-card-view-row>
      <span aza-cart-v2-order-items-card-row-label translate>TAX</span>
      <span aza-cart-v2-order-items-card-row-value>{{item.tax | twoDecNumber | addText:cartCurrency}}</span>
    </aza-rws-shopping-cart-v2-order-items-card-view-row>
    <aza-rws-shopping-cart-v2-order-items-card-view-row>
      <span aza-cart-v2-order-items-card-row-label translate>SUBTOTAL</span>
      <span aza-cart-v2-order-items-card-row-value>{{item.total | twoDecNumber | addText:cartCurrency}}</span>
    </aza-rws-shopping-cart-v2-order-items-card-view-row>
  </div>
}
<div class="aza-cart-v2-order-items-card aza-cart-v2-order-items-card-total aza-vertical-stack">
  <div class="aza-cart-v2-order-items-card-row aza-horizontal-stack">
    <div class="aza-cart-v2-order-items-card-row-label aza-cart-v2-order-items-to-pay-refund-label-container">
      @if (orderTotal < 0) {
        <span class="aza-cart-v2-order-items-refund-label" translate>REFUND</span>
      }
      @if (orderTotal >= 0) {
        <span class="aza-cart-v2-order-items-to-pay-label" translate>TO_PAY</span>
      }
    </div>
    <div class="aza-cart-v2-order-items-card-view-to-pay-refund-value-container aza-cart-v2-order-items-card-view-cell aza-cart-v2-order-items-card-view-last-cell justify-content-end aza-horizontal-stack aza-vertical-items-centered">
      @if (orderTotal < 0) {
        <span class="aza-cart-v2-order-items-refund-value">{{-orderTotal | twoDecNumber}}</span>
        <span> {{cartCurrency}}</span>
      }
      @if (orderTotal >= 0) {
        <span class="aza-cart-v2-order-items-to-pay-value">{{orderTotal | twoDecNumber}}</span>
        <span> {{cartCurrency}}</span>
      }
    </div>
  </div>
</div>
